<ps-ui-modal class="sup-group-modal">
  <h3 psUiModalTitle class="modal-title">Confirm Live URL</h3>
  <ps-ui-modal-body class="text-muted modal-body">
    <p>
      Please verify that you have entered the correct live URL for your schedule
      launch.
    </p>
  </ps-ui-modal-body>
  <ps-ui-modal-footer class="modal-footer justify-content-center">
    <button type="button" class="btn btn-primary" (click)="close('ok')">
      OK
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
